// extracted by mini-css-extract-plugin
module.exports = {"areaGraph":"AreaGraph_areaGraph___3WDo"};